var map = {
	"./index": 665,
	"./index.js": 665
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2227;



//////////////////
// WEBPACK FOOTER
// ./~/bin-wrapper ^\.\/.*$
// module id = 2227
// module chunks = 0